import { render, staticRenderFns } from "./frill-widget.vue?vue&type=template&id=4380ea54&"
import script from "./frill-widget.vue?vue&type=script&lang=ts&"
export * from "./frill-widget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports